/* ==========================================================================
 * PROMO GIFTS — pikastore Shopify Impact theme
 * --------------------------------------------------------------------------
 *  Konfigurace přichází VÝHRADNĚ z Cart drawer section blocks
 *  (Customize → Cart drawer → blocks "Promo (kód)" + "Volba (varianta/produkt)").
 *
 *  Liquid (sections/cart-drawer.liquid) vyplní:
 *      window.PIKA_PROMO_GIFTS_CONFIG = { promos: [...], options: [...] };
 *  a vyhodí event "pika:promo-config-ready".
 * ========================================================================== */
(function () {
  'use strict';

  if (window.__PIKA_PROMO_GIFTS_BOOTED) return;
  window.__PIKA_PROMO_GIFTS_BOOTED = true;

  /* =========================================================================
   * 0. DEBUG LOGGING
   *    Vypneš zadáním v konzoli: localStorage.setItem('pika_promo_debug','0')
   * ========================================================================= */
  function dbg() {
    try {
      if (localStorage.getItem('pika_promo_debug') === '0') return;
    } catch (e) {}
    var args = Array.prototype.slice.call(arguments);
    args.unshift('%c[PROMO]', 'color:#0a8;font-weight:bold');
    try { console.log.apply(console, args); } catch (e) {}
  }
  function dbgWarn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('%c[PROMO]', 'color:#c0322b;font-weight:bold');
    try { console.warn.apply(console, args); } catch (e) {}
  }

  dbg('booted', { config: window.PIKA_PROMO_GIFTS_CONFIG, locale: document.documentElement.lang });

  /* =========================================================================
   * 1. LOKALIZACE
   * ========================================================================= */
  function getLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('cs') === 0 || lang.indexOf('sk') === 0) return 'cs';
    if (window.Shopify && Shopify.locale && String(Shopify.locale).indexOf('cs') === 0) return 'cs';
    return 'en';
  }

  function pickL(obj, fallback) {
    if (!obj) return fallback || '';
    var loc = getLocale();
    return obj[loc] || obj.en || obj.cs || fallback || '';
  }

  var UI = {
    cs: {
      step2Title: 'Vyberte velikost',
      step2Desc:  'Klikněte na velikost a potvrďte přidání do košíku.',
      noSizeNeeded:    'Klikněte na "Přidat" pro přidání dárku do košíku.',
      backBtn:         '← Zpět',
      addBtn:          'Přidat zdarma do košíku',
      cancelBtn:       'Zrušit',
      closeAria:       'Zavřít',
      invalidForGift:    'Zadaný slevový kód není platný pro dárek zdarma.',
      notActiveYet:      'Tento kód zatím není aktivní.',
      expired:           'Platnost tohoto kódu už vypršela.',
      unknownCode:       'Zadaný kód neexistuje nebo je neplatný.',
      addedToCart:       'Dárek zdarma jsme přidali do košíku.',
      alreadyInCart:     'Dárek už máte v košíku.',
      variantUnavailable:'Tato varianta momentálně není dostupná.',
      addError:          'Dárek se nepodařilo přidat. Zkuste to prosím znovu.',
      configMissing:     'Promo dárek není správně nakonfigurovaný v nastavení theme.',
      sizeOOS:           'Vyprodáno'
    },
    en: {
      step2Title: 'Choose a size',
      step2Desc:  'Click a size and confirm adding to cart.',
      noSizeNeeded:    'Click "Add" to add the gift to your cart.',
      backBtn:         '← Back',
      addBtn:          'Add free to cart',
      cancelBtn:       'Cancel',
      closeAria:       'Close',
      invalidForGift:    'The discount code is not valid for a free gift.',
      notActiveYet:      'This code is not active yet.',
      expired:           'This code has expired.',
      unknownCode:       'This code does not exist or is invalid.',
      addedToCart:       'Free gift added to your cart.',
      alreadyInCart:     'The gift is already in your cart.',
      variantUnavailable:'This variant is currently unavailable.',
      addError:          'Could not add the gift. Please try again.',
      configMissing:     'Promo gift is not properly configured in theme settings.',
      sizeOOS:           'Sold out'
    }
  };

  function ui(key) {
    var loc = getLocale();
    return (UI[loc] || UI.en)[key];
  }

  /* =========================================================================
   * 2. INDEX PROMO Z CONFIGU
   * ========================================================================= */
  var INDEX = { byCode: {} };  // { CODE: { promo, options: [...] } }

  function parseVariantFilter(text) {
    if (!text) return null;
    var ids = String(text).split(/[\s,;\n]+/)
                 .map(function (s) { return s.replace(/\D/g, ''); })
                 .filter(Boolean)
                 .map(function (s) { return Number(s); });
    return ids.length ? ids : null;
  }

  function rebuildIndex() {
    var raw = window.PIKA_PROMO_GIFTS_CONFIG;
    INDEX = { byCode: {} };
    if (!raw || !Array.isArray(raw.promos)) {
      dbgWarn('config NOT loaded — window.PIKA_PROMO_GIFTS_CONFIG is missing or has no promos array. Did Cart drawer section render?');
      return;
    }
    if (!raw.promos.length) {
      dbgWarn('config has 0 promos — add at least 1 "Promo (kód)" block in Cart drawer customizer.');
    }

    raw.promos.forEach(function (p) {
      var code = (p.code || '').toUpperCase().trim();
      if (!code) return;
      INDEX.byCode[code] = { promo: p, options: [] };
    });

    if (Array.isArray(raw.options)) {
      raw.options.forEach(function (opt) {
        var code = (opt.promoCode || '').toUpperCase().trim();
        var bucket = INDEX.byCode[code];
        if (!bucket) {
          dbgWarn('option block has promo_code "' + code + '" which has no matching Promo block. Skipping.', opt);
          return;
        }

        // Filtrace variant
        var allVariants = (opt.product && Array.isArray(opt.product.variants))
          ? opt.product.variants : [];
        var filterIds = parseVariantFilter(opt.variantFilter);
        var variants = filterIds
          ? allVariants.filter(function (v) { return filterIds.indexOf(v.id) !== -1; })
          : allVariants;

        if (!variants.length) {
          dbgWarn('option block "' + code + '/' + (opt.label && (opt.label.cs || opt.label.en)) + '" has no variants — pick a product in customizer.', opt);
          return;
        }

        bucket.options.push({
          label: opt.label || {},
          handle: (opt.product && opt.product.handle) || '',
          productTitle: (opt.product && opt.product.title) || '',
          image: (opt.product && opt.product.image) || '',
          variants: variants
        });
      });
    }
  }

  function logIndex() {
    var keys = Object.keys(INDEX.byCode);
    dbg('INDEX rebuilt – known codes:', keys, INDEX.byCode);
  }
  rebuildIndex();
  logIndex();
  document.addEventListener('pika:promo-config-ready', function () {
    rebuildIndex();
    logIndex();
  });

  function getPromoBundle(code) {
    if (!code) return null;
    return INDEX.byCode[String(code).toUpperCase().trim()] || null;
  }

  function isPromoCodeKnown(code) { return !!getPromoBundle(code); }

  /* =========================================================================
   * 3. UTILITY
   * ========================================================================= */
  var ACTIVE_CODE_KEY = 'pika_promo_active_code';

  function saveActivePromoCode(code) {
    try { localStorage.setItem(ACTIVE_CODE_KEY, String(code).toUpperCase().trim()); } catch (e) {}
  }
  function clearActivePromoCode() {
    try { localStorage.removeItem(ACTIVE_CODE_KEY); } catch (e) {}
  }
  function getActivePromoCode() {
    try { return localStorage.getItem(ACTIVE_CODE_KEY) || ''; } catch (e) { return ''; }
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function normalizeCat(s) {
    return String(s || '').toLowerCase().trim();
  }

  // Match: wanted token musí být buď přesně rovný hodnotě, NEBO musí
  // být některá z jejích "/", ">" nebo "," oddělených částí, NEBO
  // musí být v ní jako slovo (oddělené non-word charem).
  function categoryFieldMatches(fieldValue, wanted) {
    if (!fieldValue) return false;
    var v = normalizeCat(fieldValue);
    if (!v) return false;
    if (v === wanted) return true;
    // split na běžných oddělovačích taxonomy / tag listů
    var parts = v.split(/[>,/|;]+/).map(function (s) { return s.trim(); });
    if (parts.indexOf(wanted) !== -1) return true;
    // word-boundary search (např. "category:Shoes" → najde "shoes")
    var re = new RegExp('(^|[^a-z0-9])' + wanted.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-z0-9]|$)', 'i');
    return re.test(v);
  }

  // Mini CS↔EN slovník pro nejčastější Shopify Standard Product Taxonomy
  // názvy v módě. `taxonomy_category.name` je lokalizovaný — pokud má shop
  // jazyk cs, Shopify vrátí "Boty", uživatel ale v adminu napsal "Shoes"
  // (nebo opačně). Před matchem expandnem obě strany na možné varianty.
  var CAT_ALIASES = {
    'shoes':    ['shoes', 'boty', 'obuv'],
    'boty':     ['boty', 'shoes', 'obuv'],
    'obuv':     ['obuv', 'shoes', 'boty'],
    'sneakers': ['sneakers', 'tenisky', 'shoes', 'boty'],
    'tenisky':  ['tenisky', 'sneakers', 'shoes', 'boty'],
    'apparel & accessories': ['apparel & accessories', 'oblečení a doplňky', 'oděvy a doplňky'],
    'clothing': ['clothing', 'oblečení', 'oděvy'],
    'oblečení': ['oblečení', 'clothing', 'oděvy'],
    'socks':    ['socks', 'ponožky'],
    'ponožky':  ['ponožky', 'socks'],
    'hats':     ['hats', 'klobouky', 'čepice'],
    'shorts':   ['shorts', 'kraťasy', 'šortky'],
    't-shirts': ['t-shirts', 'tričko', 'trička']
  };

  function expandAliases(token) {
    var t = normalizeCat(token);
    if (!t) return [];
    return CAT_ALIASES[t] || [t];
  }

  // wantedRaw může být i comma-separated ("Shoes, Boty, aa-1-1") — pak match
  // pokud aspoň jeden z tokenů sedí proti nějakému zdroji.
  function tokenizeWanted(wantedRaw) {
    var s = String(wantedRaw || '').toLowerCase();
    var raw = s.split(/[,;]+/).map(function (t) { return t.trim(); }).filter(Boolean);
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var aliases = expandAliases(raw[i]);
      for (var j = 0; j < aliases.length; j++) {
        if (out.indexOf(aliases[j]) === -1) out.push(aliases[j]);
      }
    }
    return out;
  }

  function anyTokenMatchesField(fieldValue, tokens) {
    if (!fieldValue) return null;
    for (var i = 0; i < tokens.length; i++) {
      if (categoryFieldMatches(fieldValue, tokens[i])) return tokens[i];
    }
    return null;
  }

  function cartHasProductCategory(cart, wantedRaw) {
    var tokens = tokenizeWanted(wantedRaw);
    if (!tokens.length) return true;

    var checked = [];

    // 1) DOM line-itemy
    var lineNodes = document.querySelectorAll('line-item');
    for (var i = 0; i < lineNodes.length; i++) {
      var n = lineNodes[i];
      var fields = {
        cat:  n.getAttribute('data-product-category'),
        id:   n.getAttribute('data-product-category-id'),
        full: n.getAttribute('data-product-category-full'),
        typ:  n.getAttribute('data-product-type'),
        tags: n.getAttribute('data-product-tags')
      };
      checked.push(fields);
      for (var f in fields) {
        var hit = anyTokenMatchesField(fields[f], tokens);
        if (hit) { dbg('cat match via DOM[' + f + ']=' + fields[f] + ' on token=' + hit); return true; }
      }
    }

    // 2) Server-side cartItems z PIKA_PROMO_GIFTS_CONFIG
    var ssItems = window.PIKA_PROMO_GIFTS_CONFIG && window.PIKA_PROMO_GIFTS_CONFIG.cartItems;
    if (Array.isArray(ssItems)) {
      for (var s = 0; s < ssItems.length; s++) {
        var si = ssItems[s] || {};
        var ssFields = { cat: si.category, id: si.categoryId, full: si.categoryFull, typ: si.type, tags: si.tags };
        checked.push({ src: 'ss', cat: si.category, id: si.categoryId, full: si.categoryFull, type: si.type, tags: si.tags });
        for (var k in ssFields) {
          var hit2 = anyTokenMatchesField(ssFields[k], tokens);
          if (hit2) { dbg('cat match via SS[' + k + ']=' + ssFields[k] + ' on token=' + hit2); return true; }
        }
      }
    }

    // 3) Cart.js items
    if (cart && Array.isArray(cart.items)) {
      for (var jj = 0; jj < cart.items.length; jj++) {
        var it = cart.items[jj];
        var hit3 = anyTokenMatchesField(it.product_type, tokens);
        if (hit3) { dbg('cat match via /cart.js product_type=' + it.product_type + ' on token=' + hit3); return true; }
        if (it.properties) {
          var hit4 = anyTokenMatchesField(it.properties._category, tokens);
          if (hit4) { dbg('cat match via line _category=' + it.properties._category + ' on token=' + hit4); return true; }
        }
      }
    }

    // 4) Generický DOM fallback
    var anyTyped = document.querySelectorAll('[data-product-category],[data-product-category-id],[data-product-category-full],[data-product-type],[data-product-tags]');
    for (var p = 0; p < anyTyped.length; p++) {
      var el = anyTyped[p];
      if (lineNodes.length && Array.prototype.indexOf.call(lineNodes, el) !== -1) continue;
      if (anyTokenMatchesField(el.getAttribute('data-product-category'),      tokens)) return true;
      if (anyTokenMatchesField(el.getAttribute('data-product-category-id'),   tokens)) return true;
      if (anyTokenMatchesField(el.getAttribute('data-product-category-full'), tokens)) return true;
      if (anyTokenMatchesField(el.getAttribute('data-product-type'),          tokens)) return true;
      if (anyTokenMatchesField(el.getAttribute('data-product-tags'),          tokens)) return true;
    }

    dbgWarn('cat NO MATCH. Wanted tokens:', tokens, 'Items inspected:', checked);
    return false;
  }

  function promoRequirementsMet(promo, cart) {
    var req = promo.requiresProductCategory || promo.requiresProductType;
    if (!req) return true;
    return cartHasProductCategory(cart, req);
  }

  /* ----- VALIDITY (in-app expirace promo akce) -----------------------------
   *  validFrom / validUntil přicházejí z cart-drawer schema jako ISO string
   *  ("2026-05-20", "2026-05-20T10:00", "2026-05-20 10:00" …). Když je
   *  parsovat nelze, bereme jako "bez hranice".
   * ----------------------------------------------------------------------- */
  function parseDateLoose(s) {
    if (!s) return null;
    var str = String(s).trim();
    if (!str) return null;
    // Akceptuj formáty "YYYY-MM-DD HH:MM" — převeď mezeru na "T".
    if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(str)) str = str.replace(' ', 'T');
    var d = new Date(str);
    if (isNaN(d.getTime())) return null;
    return d;
  }

  /* Vrátí 'active' | 'pending' | 'expired' */
  function getPromoValidityState(promo) {
    if (!promo) return 'expired';
    if (!promo.active) return 'pending';
    var now = Date.now();
    var from = parseDateLoose(promo.validFrom);
    var until = parseDateLoose(promo.validUntil);
    if (from && now < from.getTime()) return 'pending';
    if (until && now > until.getTime()) return 'expired';
    return 'active';
  }

  /* =========================================================================
   * 4. TOAST
   * ========================================================================= */
  function ensureToastHost() {
    var host = document.getElementById('pika-promo-toast-host');
    if (host) return host;
    host = document.createElement('div');
    host.id = 'pika-promo-toast-host';
    document.body.appendChild(host);
    return host;
  }

  function showToast(message, kind) {
    if (!message) return;
    var host = ensureToastHost();
    var el = document.createElement('div');
    el.className = 'pika-promo-toast' + (kind === 'error' ? ' is-error' : '');
    el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
    el.textContent = message;
    host.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 220);
    }, 3500);
  }
  function showInfo(msg)  { showToast(msg, 'info'); }
  function showError(msg) { showToast(msg, 'error'); }

  /* =========================================================================
   * 5. MODAL
   * ========================================================================= */
  var modalState = {
    backdrop: null, bundle: null, option: null, variant: null,
    step: 1, busy: false, lastFocus: null
  };

  /* ----- Drawer outside-click patch ---------------------------------------
   *  Impact theme používá focus-trap knihovnu která na klik mimo
   *  <cart-drawer> zavolá drawer.hide(). Náš modal je v <body>, takže klik
   *  na barvu / velikost / Add by drawer zavřel. Patchneme Drawer prototype
   *  tak, aby klik uvnitř našeho backdropu NEbyl považován za „outside".
   * ----------------------------------------------------------------------- */
  function patchDrawerOutsideClick() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var Ctor = customElements.get('cart-drawer');
      if (!Ctor) return;
      var Proto = Ctor.prototype;
      while (Proto && !Object.prototype.hasOwnProperty.call(Proto, '_allowOutsideClickMouse')) {
        Proto = Object.getPrototypeOf(Proto);
      }
      if (!Proto || Proto.__pikaPromoPatched) return;
      Proto.__pikaPromoPatched = true;

      function isInsidePromoModal(target) {
        var bd = modalState.backdrop;
        if (!bd || bd.hasAttribute('hidden')) return false;
        return bd === target || bd.contains(target);
      }

      var origMouse = Proto._allowOutsideClickMouse;
      Proto._allowOutsideClickMouse = function (event) {
        if (event && isInsidePromoModal(event.target)) return true;
        return origMouse.call(this, event);
      };

      var origTouch = Proto._allowOutsideClickTouch;
      if (typeof origTouch === 'function') {
        Proto._allowOutsideClickTouch = function (event) {
          if (event && isInsidePromoModal(event.target)) return true;
          return origTouch.call(this, event);
        };
      }

      dbg('Drawer prototype patched — promo modal clicks no longer close drawer');
    }).catch(function () { /* customElements.whenDefined rejected (unlikely) */ });
  }
  patchDrawerOutsideClick();

  function buildModalShell() {
    if (modalState.backdrop) return modalState.backdrop;

    var b = document.createElement('div');
    b.className = 'pika-promo-modal__backdrop';
    b.setAttribute('hidden', '');
    b.innerHTML =
      '<div class="pika-promo-modal" role="dialog" aria-modal="true" aria-labelledby="pika-promo-modal-title">' +
        '<button type="button" class="pika-promo-modal__close" aria-label="">×</button>' +

        '<section class="pika-promo-modal__step pika-promo-modal__step--1">' +
          '<h2 id="pika-promo-modal-title" class="pika-promo-modal__title"></h2>' +
          '<p class="pika-promo-modal__desc"></p>' +
          '<div class="pika-promo-modal__colors"></div>' +
          '<p class="pika-promo-modal__hint"></p>' +
          '<div class="pika-promo-modal__actions">' +
            '<button type="button" class="pika-promo-modal__cancel"></button>' +
          '</div>' +
        '</section>' +

        '<section class="pika-promo-modal__step pika-promo-modal__step--2" hidden>' +
          '<h2 class="pika-promo-modal__title pika-promo-modal__title-2"></h2>' +
          '<p class="pika-promo-modal__desc pika-promo-modal__desc-2"></p>' +
          '<div class="pika-promo-modal__chosen-color"></div>' +
          '<div class="pika-promo-modal__sizes" role="radiogroup"></div>' +
          '<div class="pika-promo-modal__actions">' +
            '<button type="button" class="pika-promo-modal__back"></button>' +
            '<button type="button" class="pika-promo-modal__add" disabled></button>' +
          '</div>' +
        '</section>' +

        '<div class="pika-promo-modal__loader" hidden><span></span></div>' +
      '</div>';

    document.body.appendChild(b);

    b.addEventListener('click', function (ev) { if (ev.target === b) closeModal(); });
    b.querySelector('.pika-promo-modal__close').addEventListener('click', closeModal);
    b.querySelector('.pika-promo-modal__cancel').addEventListener('click', closeModal);
    b.querySelector('.pika-promo-modal__back').addEventListener('click', function () { goToStep(1); });
    b.querySelector('.pika-promo-modal__add').addEventListener('click', onConfirmAdd);

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !b.hasAttribute('hidden')) closeModal();
    });

    modalState.backdrop = b;
    return b;
  }

  function closeModal() {
    var b = modalState.backdrop;
    if (!b || b.hasAttribute('hidden')) return;
    b.setAttribute('hidden', '');
    document.documentElement.classList.remove('pika-promo-modal-open');
    modalState.bundle = null; modalState.option = null;
    modalState.variant = null; modalState.step = 1;
    if (modalState.lastFocus && typeof modalState.lastFocus.focus === 'function') {
      try { modalState.lastFocus.focus(); } catch (e) {}
    }
  }

  function setModalBusy(busy) {
    modalState.busy = busy;
    if (!modalState.backdrop) return;
    var loader = modalState.backdrop.querySelector('.pika-promo-modal__loader');
    if (busy) loader.removeAttribute('hidden');
    else      loader.setAttribute('hidden', '');
  }

  function goToStep(step) {
    if (!modalState.backdrop) return;
    modalState.step = step;
    var s1 = modalState.backdrop.querySelector('.pika-promo-modal__step--1');
    var s2 = modalState.backdrop.querySelector('.pika-promo-modal__step--2');
    if (step === 1) { s1.hidden = false; s2.hidden = true; }
    else            { s1.hidden = true;  s2.hidden = false; }
  }

  function openPromoModal(bundle) {
    var b = buildModalShell();
    modalState.bundle  = bundle;
    modalState.option  = null;
    modalState.variant = null;

    var p = bundle.promo;
    b.querySelector('.pika-promo-modal__close').setAttribute('aria-label', ui('closeAria'));
    b.querySelector('#pika-promo-modal-title').textContent = pickL(p.title);
    b.querySelector('.pika-promo-modal__desc').textContent  = pickL(p.desc);
    b.querySelector('.pika-promo-modal__hint').textContent  = pickL(p.shopifyDiscountInfo, '');
    b.querySelector('.pika-promo-modal__cancel').textContent = ui('cancelBtn');
    b.querySelector('.pika-promo-modal__back').textContent   = ui('backBtn');
    b.querySelector('.pika-promo-modal__add').textContent    = ui('addBtn');
    b.querySelector('.pika-promo-modal__title-2').textContent = ui('step2Title');
    b.querySelector('.pika-promo-modal__desc-2').textContent  = ui('step2Desc');

    var colorsWrap = b.querySelector('.pika-promo-modal__colors');
    colorsWrap.innerHTML = '';

    if (!bundle.options.length) {
      showError(ui('configMissing'));
      return;
    }

    bundle.options.forEach(function (opt, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pika-promo-color';
      btn.dataset.optionIdx = String(idx);
      btn.setAttribute('aria-label', pickL(opt.label, opt.productTitle));

      var img = opt.image
        ? '<img src="' + opt.image + '" alt="" loading="lazy">'
        : '<span class="pika-promo-color__placeholder"></span>';

      btn.innerHTML =
        '<span class="pika-promo-color__media">' + img + '</span>' +
        '<span class="pika-promo-color__label">' + pickL(opt.label, opt.productTitle) + '</span>';

      btn.addEventListener('click', function () { onOptionPicked(opt); });
      colorsWrap.appendChild(btn);
    });

    goToStep(1);
    modalState.lastFocus = document.activeElement;
    b.removeAttribute('hidden');
    document.documentElement.classList.add('pika-promo-modal-open');

    setTimeout(function () {
      var first = colorsWrap.querySelector('.pika-promo-color');
      if (first) first.focus();
    }, 30);
  }

  function onOptionPicked(opt) {
    if (modalState.busy) return;
    modalState.option = opt;
    renderSizeStep();
  }

  function renderSizeStep() {
    var b = modalState.backdrop;
    var sizesWrap = b.querySelector('.pika-promo-modal__sizes');
    var chosen    = b.querySelector('.pika-promo-modal__chosen-color');
    var addBtn    = b.querySelector('.pika-promo-modal__add');
    var opt       = modalState.option;

    chosen.innerHTML = '';
    if (opt) {
      var src = opt.image || '';
      chosen.innerHTML =
        (src ? '<span class="pika-promo-modal__chosen-img"><img src="' + src + '" alt=""></span>' : '') +
        '<strong>' + pickL(opt.label, opt.productTitle) + '</strong>';
    }

    sizesWrap.innerHTML = '';
    addBtn.disabled = true;
    modalState.variant = null;

    var variants = (opt.variants || []).filter(Boolean);

    if (variants.length === 1) {
      var v0 = variants[0];
      modalState.variant = v0;
      addBtn.disabled = !v0.available;
      sizesWrap.innerHTML =
        '<p class="pika-promo-modal__no-size">' +
          (v0.available ? ui('noSizeNeeded') : ui('variantUnavailable')) +
        '</p>';
      goToStep(2);
      return;
    }

    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pika-promo-size';
      btn.dataset.variantId = String(v.id);
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.innerHTML =
        '<span class="pika-promo-size__label">' + (v.title || '') + '</span>' +
        (v.available ? '' : '<span class="pika-promo-size__oos">' + ui('sizeOOS') + '</span>');
      if (!v.available) {
        btn.disabled = true;
        btn.classList.add('is-disabled');
      } else {
        btn.addEventListener('click', function () {
          sizesWrap.querySelectorAll('.pika-promo-size').forEach(function (n) {
            n.classList.remove('is-selected');
            n.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
          modalState.variant = v;
          addBtn.disabled = false;
        });
      }
      sizesWrap.appendChild(btn);
    });

    goToStep(2);
    setTimeout(function () {
      var first = sizesWrap.querySelector('.pika-promo-size:not(.is-disabled)');
      if (first) first.focus();
    }, 30);
  }

  function onConfirmAdd() {
    if (modalState.busy) return;
    if (!modalState.variant || !modalState.bundle) return;
    addPromoGift(modalState.variant.id, modalState.bundle.promo);
  }

  /* =========================================================================
   * 6. APLIKACE / ODSTRANĚNÍ SHOPIFY DISCOUNT CODE NA CART
   *
   *  /cart/update.js přijímá `discount` jako comma-separated seznam VŠECH
   *  kódů, které mají být aplikované — replace, ne append. Proto vždy bereme
   *  aktuálně aplikované kódy + přidáme/odebereme náš a pošleme zpět.
   * ========================================================================= */
  function getAppliedDiscountCodes(cart) {
    return ((cart && cart.discount_codes) || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; });
  }

  function applyShopifyDiscount(code) {
    return getCart().then(function (cart) {
      var existing = getAppliedDiscountCodes(cart);
      var codeUp = code.toUpperCase();
      if (existing.some(function (c) { return c.toUpperCase() === codeUp; })) {
        dbg('discount already applied:', code);
        return Promise.resolve();
      }
      var combined = existing.concat([code]).join(',');
      dbg('applying Shopify discount codes:', combined);
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: combined })
      });
    });
  }

  function removeShopifyDiscount(code) {
    return getCart().then(function (cart) {
      var existing = getAppliedDiscountCodes(cart);
      var codeUp = code.toUpperCase();
      if (!existing.some(function (c) { return c.toUpperCase() === codeUp; })) {
        return Promise.resolve();
      }
      var remaining = existing.filter(function (c) { return c.toUpperCase() !== codeUp; }).join(',');
      dbg('removing Shopify discount, remaining:', remaining || '(none)');
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: remaining })
      });
    });
  }

  /* =========================================================================
   * 7. PŘIDÁNÍ / ODSTRANĚNÍ DÁRKU
   * ========================================================================= */
  function addPromoGift(variantId, promo) {
    setModalBusy(true);

    getCart().then(function (cart) {
      var toRemove = (cart.items || []).filter(function (it) {
        return it.properties &&
               it.properties._promo_gift === 'true' &&
               it.properties._promo_code === promo.code;
      });
      var seq = Promise.resolve();
      toRemove.forEach(function (it) {
        seq = seq.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: 0 })
          });
        });
      });
      return seq;
    })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            '_promo_gift': 'true',
            '_promo_code': promo.code,
            '_promo_type': promo.code.toLowerCase()
          }
        })
      });
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) { throw err; }, function () { throw new Error('add_failed'); });
      }
      return res.json();
    })
    .then(function () {
      saveActivePromoCode(promo.code);
      // Aplikuj Shopify discount code na cart — sleva (Buy X Get Y → Free)
      // se propíše ihned, gift line bude 0 Kč už v cart draweru.
      return applyShopifyDiscount(promo.code).catch(function (e) {
        // Nezablokujeme UX — gift je přidán; sleva se uplatní aspoň
        // v checkoutu přes /discount/CODE?redirect=/checkout.
        dbgWarn('applyShopifyDiscount failed (will still work at checkout):', e);
      });
    })
    .then(function () {
      setModalBusy(false);
      closeModal();
      showInfo(ui('addedToCart'));
      refreshCartDrawer();
    })
    .catch(function (err) {
      setModalBusy(false);
      var msg = ui('addError');
      if (err && (err.status === 422 || err.description)) msg = ui('variantUnavailable');
      showError(msg);
    });
  }

  function removeAllGiftLinesByCode(cart, code) {
    var seq = Promise.resolve();
    (cart.items || []).forEach(function (it) {
      if (it.properties &&
          it.properties._promo_gift === 'true' &&
          it.properties._promo_code === code) {
        seq = seq.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: 0 })
          });
        });
      }
    });
    return seq;
  }

  var cleanupRunning = false;
  function removeInvalidPromoGifts() {
    if (cleanupRunning) return;
    cleanupRunning = true;
    var didRemoveAny = false;
    getCart().then(function (cart) {
      var giftCodes = {};
      (cart.items || []).forEach(function (it) {
        if (it.properties && it.properties._promo_gift === 'true' && it.properties._promo_code) {
          giftCodes[it.properties._promo_code] = true;
        }
      });
      var seq = Promise.resolve();
      Object.keys(giftCodes).forEach(function (code) {
        var bundle = getPromoBundle(code);
        var shouldRemove = false;
        var reason = '';
        if (!bundle) { shouldRemove = true; reason = 'unknown promo'; }
        else {
          var st = getPromoValidityState(bundle.promo);
          if (st === 'pending')                                  { shouldRemove = true; reason = 'promo not yet active'; }
          else if (st === 'expired')                             { shouldRemove = true; reason = 'promo expired'; }
          else if (!promoRequirementsMet(bundle.promo, cart))    { shouldRemove = true; reason = 'requirements not met'; }
        }

        if (shouldRemove) {
          didRemoveAny = true;
          dbg('cleanup: removing gift for code', code, 'reason:', reason);
          seq = seq
            .then(function () { return removeAllGiftLinesByCode(cart, code); })
            .then(function () { return removeShopifyDiscount(code).catch(function (e) { dbgWarn('removeShopifyDiscount failed:', e); }); });
          if (getActivePromoCode() === code) clearActivePromoCode();
        }
      });
      return seq;
    })
    .then(function () {
      cleanupRunning = false;
      if (didRemoveAny) {
        // Po smazání giftu z košíku theme sám cart drawer NEPŘERENDRUJE.
        // Dispatchneme cart:refresh, který fíruje Section Rendering API a UI se updatne.
        dbg('cleanup done — dispatching cart:refresh to re-render drawer');
        refreshCartDrawer();
      }
    })
    .catch(function () { cleanupRunning = false; });
  }

  /* =========================================================================
   * 7. INPUT INTERCEPT
   * ========================================================================= */
  function isInsideDiscountField(t) {
    return !!(t && t.closest && t.closest('cart-discount-field'));
  }

  function tryIntercept(target) {
    if (!target || !target.value) return false;
    var raw = target.value;
    dbg('intercept check: input value =', JSON.stringify(raw), 'known codes:', Object.keys(INDEX.byCode));
    if (!isPromoCodeKnown(raw)) {
      dbg('intercept SKIPPED — code not in INDEX. Letting Shopify handle it.');
      return false;
    }
    dbg('intercept HIT — running promo flow for', raw);

    target.value = '';

    var field = target.closest('cart-discount-field');
    if (field) {
      var hidden = field.querySelector('input[type="hidden"][name="discount"]');
      if (hidden) {
        var parts = (hidden.value || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var rawUp = String(raw).toUpperCase().trim();
        var cleaned = parts.filter(function (p) { return p.toUpperCase() !== rawUp; });
        hidden.value = cleaned.join(',');
      }
    }

    handleApply(raw);
    return true;
  }

  function handleApply(rawCode) {
    var bundle = getPromoBundle(rawCode);
    if (!bundle) return false;

    var promo = bundle.promo;
    dbg('handleApply', {
      code: rawCode, active: promo.active, options: bundle.options.length,
      validFrom: promo.validFrom, validUntil: promo.validUntil
    });

    var state = getPromoValidityState(promo);
    if (state === 'pending') {
      dbg('promo not yet active — showing toast');
      showError(ui('notActiveYet'));
      return true;
    }
    if (state === 'expired') {
      dbg('promo expired — showing toast');
      showError(ui('expired'));
      return true;
    }

    if (!bundle.options.length) {
      dbgWarn('promo active but has 0 valid options (no products picked?) — showing toast');
      showError(ui('configMissing'));
      return true;
    }

    getCart().then(function (cart) {
      if (!promoRequirementsMet(promo, cart)) {
        // Pickl s tvrdým fallbackem — pokud uživatel nechá oba překlady prázdné,
        // i tak vždy ukážeme něco rozumného.
        var msg = pickL(promo.wrongTypeMsg, '');
        if (!msg) msg = ui('invalidForGift');
        showError(msg);
        return;
      }
      var hasGift = (cart.items || []).some(function (it) {
        return it.properties &&
               it.properties._promo_gift === 'true' &&
               it.properties._promo_code === promo.code;
      });
      if (hasGift) showInfo(ui('alreadyInCart'));
      openPromoModal(bundle);
    });

    return true;
  }

  // INPUT — auto-fire jakmile hodnota PŘESNĚ matchne známý promo kód.
  // Funguje pro typing, paste, autofill — bez nutnosti Enter / blur.
  // Vyžaduje exact match — nelovíme prefixy (CREAS, CREASE…).
  //
  // Záměrně NEpoužíváme stopImmediatePropagation: tryIntercept() vyčistí
  // target.value = '', a theme's input listener (bubble fáze) potom nastaví
  // hidden accumulator na original applied codes (bez naší promo hodnoty).
  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (!t || !isInsideDiscountField(t) || t.type === 'hidden') return;
    var raw = (t.value || '').trim();
    if (!raw) return;
    if (!isPromoCodeKnown(raw)) return;
    dbg('input auto-fire — exact match', raw);
    tryIntercept(t);
  }, true);

  // CHANGE — záložní handler pro starší autofill / programové změny value
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !isInsideDiscountField(t) || t.type === 'hidden') return;
    if (tryIntercept(t)) {
      ev.stopImmediatePropagation();
      ev.preventDefault();
    }
  }, true);

  // KEYDOWN Enter — záložní pro browsery které nefírují change na Enter
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var t = ev.target;
    if (!t || !isInsideDiscountField(t) || t.type === 'hidden') return;
    if (!isPromoCodeKnown(t.value)) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    tryIntercept(t);
  }, true);

  /* ----- UNKNOWN-CODE FEEDBACK --------------------------------------------
   *  Když uživatel zadá kód, který NENÍ promo gift kód, necháme Shopify aby
   *  ho zkusil uplatnit jako klasickou slevu. Po krátké pauze ověříme přes
   *  /cart.js, jestli se kód skutečně aplikoval (applicable=true). Pokud ne,
   *  ukážeme srozumitelnou hlášku, ať uživatel ví, že kód neexistuje /
   *  není platný — ne aby jen "zmizel".
   * ----------------------------------------------------------------------- */
  var unknownWatch = { code: '', timer: null };
  function scheduleUnknownCodeCheck(rawValue) {
    var code = String(rawValue || '').trim();
    if (!code) return;
    if (isPromoCodeKnown(code)) return; // známé promo už řeší handleApply
    unknownWatch.code = code;
    if (unknownWatch.timer) clearTimeout(unknownWatch.timer);
    unknownWatch.timer = setTimeout(function () {
      var watching = unknownWatch.code;
      unknownWatch.code = '';
      unknownWatch.timer = null;
      if (!watching) return;
      getCart().then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        var matched = codes.some(function (d) {
          return d.code && String(d.code).toUpperCase() === watching.toUpperCase() && d.applicable;
        });
        if (!matched) {
          dbg('unknown code feedback — toast for', watching);
          showError(ui('unknownCode'));
        }
      }).catch(function () { /* tichý fail */ });
    }, 900);
  }

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var t = ev.target;
    if (!t || !isInsideDiscountField(t) || t.type === 'hidden') return;
    if (isPromoCodeKnown(t.value)) return; // řeší dřívější handler
    scheduleUnknownCodeCheck(t.value);
  }, true);

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !isInsideDiscountField(t) || t.type === 'hidden') return;
    if (isPromoCodeKnown(t.value)) return;
    scheduleUnknownCodeCheck(t.value);
  }, true);

  /* =========================================================================
   * 8. GIFT QTY STEPPER (cart drawer / cart page)
   *
   *  Gift line má zamčené qty na 1 a vlastní stepper:
   *    [ − ]    1    [ + ]
   *      └─ remove-gift     └─ add-regular (non-gift kopie produktu, plná cena)
   *
   *  Window-level capture, aby fíroval PŘED theme stepperem
   *  (line-item.liquid registruje document-capture handler).
   * ========================================================================= */
  function setBtnBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  function handleRemoveGift(lineEl, btn) {
    var key  = lineEl.dataset.lineKey;
    var code = (lineEl.dataset.promoCode || '').toUpperCase();
    if (!key) return;
    setBtnBusy(btn, true);
    dbg('gift stepper: remove-gift', { key: key, code: code });

    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function () {
      if (!code) return null;
      return removeShopifyDiscount(code).catch(function (e) { dbgWarn('removeShopifyDiscount failed:', e); });
    })
    .then(function () {
      if (code && getActivePromoCode().toUpperCase() === code) clearActivePromoCode();
      refreshCartDrawer();
    })
    .catch(function (e) { dbgWarn('remove-gift failed:', e); })
    .then(function () { setBtnBusy(btn, false); });
  }

  function handleAddRegularCopy(btn) {
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    setBtnBusy(btn, true);
    dbg('gift stepper: add non-gift copy', vid);

    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw e; }, function () { throw new Error('add_failed'); });
      return res.json();
    })
    .then(function () { refreshCartDrawer(); })
    .catch(function (err) {
      dbgWarn('add-regular failed:', err);
      var msg = ui('addError');
      if (err && (err.status === 422 || err.description)) msg = ui('variantUnavailable');
      showError(msg);
    })
    .then(function () { setBtnBusy(btn, false); });
  }

  window.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-pg-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-pg-action');
    if (action !== 'remove-gift' && action !== 'add-regular') return;

    ev.stopImmediatePropagation();
    ev.preventDefault();

    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    var lineEl = btn.closest('line-item, .line-item');
    if (!lineEl) return;

    if (action === 'remove-gift')   handleRemoveGift(lineEl, btn);
    else if (action === 'add-regular') handleAddRegularCopy(btn);
  }, true);

  /* =========================================================================
   * 9. CHECKOUT REDIRECT
   * ========================================================================= */
  function attachCheckoutHook() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest
        ? ev.target.closest('button[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]')
        : null;
      if (!btn) return;

      var active = getActivePromoCode();
      if (!active) return;

      var bundle = getPromoBundle(active);
      if (!bundle || getPromoValidityState(bundle.promo) !== 'active') {
        clearActivePromoCode();
        return;
      }

      ev.preventDefault();
      ev.stopPropagation();

      getCart().then(function (cart) {
        var hasGift = (cart.items || []).some(function (it) {
          return it.properties &&
                 it.properties._promo_gift === 'true' &&
                 it.properties._promo_code === active;
        });
        var url = hasGift
          ? ('/discount/' + encodeURIComponent(active) + '?redirect=/checkout')
          : '/checkout';
        window.location.href = url;
      })
      .catch(function () { window.location.href = '/checkout'; });
    }, true);
  }

  /* =========================================================================
   * 9. SYNC
   *  (Štítek „Dárek k objednávce" renderuje line-item.liquid přímo
   *   přes Section Rendering API — žádný JS decorate timing.)
   * ========================================================================= */
  function onCartChanged() {
    setTimeout(function () {
      removeInvalidPromoGifts();
    }, 80);
  }

  document.addEventListener('cart:change',  onCartChanged);
  document.addEventListener('cart:refresh', onCartChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachCheckoutHook();
      onCartChanged();
    });
  } else {
    attachCheckoutHook();
    onCartChanged();
  }
})();
